import { form } from '../formState'
import { useTexts } from '../../hooks/useTexts'
import { useTimeFormatOptions } from '../hooks/useTimeFormatOptions'

export function TimeFormat() {
  const texts = useTexts()
  const options = useTimeFormatOptions()

  return (
    <form.RadioGroup
      label={texts.timeFormat}
      validateOn="change"
      name="timeFormat"
      testId="timeFormat"
      options={options}
    />
  )
}
